/**
 * HomePage - New Homepage Design
 *
 * Feature flag removed - always uses NewHomePage component
 */

import React from 'react';
import { NewHomePage } from '../components/homepage/NewHomePage';

export const HomePage: React.FC = () => {
  return <NewHomePage />;
};
